import { TextField, Theme } from "@material-ui/core";
import { Autocomplete, Select, MenuItem, IconButton } from "@mui/material";
import React, {useEffect, useState} from "react";

import { CheckCircle, Error, Delete } from "@mui/icons-material";


const AddVariableRow = (props) => {
    let [value, setValue] = useState()
    let [units, setUnits] = useState()
    let [loe, setLOE] = useState("Medium")

    let [variable, setVariable] = useState(props.variable)


    const updateForm = () => {
        let updatedVariable = {
            name: variable.variable_name,
            value: value,
            unit: units,
            collection_method_loe: loe,
            added: props.variable.success
        }

        props.callback(props.row_id, updatedVariable)
    }

    useEffect(() => {
        updateForm();
    },[value, units, loe])

    let defaultUnits = null;
    if (props.variable.defaultValue && props.variable.defaultValue.units) {
        defaultUnits = props.units.find(u => u.brick_unit === props.variable.defaultValue.units || u.name === props.variable.defaultValue.units)
    } else if (props.variable.inheritedValue && props.variable.inheritedValue.units) {
        defaultUnits = props.units.find(u => u.brick_unit === props.variable.inheritedValue.units || u.name === props.variable.inheritedValue.units)
    } else defaultUnits = props.units.find(u => u.brick_unit === units)

    let className = props.variable.error ? "add-row row-toast" : "add-row" 
    return (
        <div className={className}>
            <div className="row-error">{props.variable.error}</div>
            <div className="row-text-field" style={{width: 300}}>
                { props.variable.variable_name }
            </div>
            <div className="row-form-field">
                { props.variable.defaultValue ?
                    <TextField label="value" variant="outlined" value={value == null ? props.variable.defaultValue &&  props.variable.defaultValue.value: value} size="small" onChange={(e) => {setValue(e.target.value)}} style={{width: 250, backgroundColor: "#ff453831"}} required />
                    : props.variable.inheritedValue ?
                    <TextField label="value" variant="outlined" value={value == null ? props.variable.inheritedValue &&  props.variable.inheritedValue.value: value} size="small" onChange={(e) => {setValue(e.target.value)}} style={{width: 250, backgroundColor: "#00b0873b"}} required InputLabelProps={{ shrink: true }}/>
                    : props.variable.options && props.variable.options.length > 0 ?
                    <Autocomplete
                        disablePortal
                        id="options"
                        options={props.variable.options}
                        style={{ width: "250px" }}
                        renderInput={(params) => <TextField {...params} label="Value" variant="outlined" size="small" required />}
                        onChange={(event, newValue) => {
                            setValue(newValue)
                        }}
                    /> :
                    <TextField label="value" variant="outlined" size="small" onChange={(e) => {setValue(e.target.value)}} style={{width: 250}} required />
                }
                
            </div>
            <div className="row-form-field">
                <Autocomplete
                        disablePortal
                        id="units"
                        options={props.units || []}
                        getOptionLabel={option => option.name}
                        style={{ width: "200px" }}
                        value={defaultUnits}
                        renderInput={(params) => <TextField {...params} label="Units" variant="outlined" size="small" />}
                        groupBy={(option) => option.parent}
                        onChange={(event, newValue) => {
                            console.log(newValue)
                            setUnits(newValue.brick_unit)
                        }}
                    />
            </div>
            <div className="row-form-field">
                <Select
                    id="loe"
                    size="small"
                    variant="outlined"
                    defaultValue={ props.variable.defaultValue ? "Easy" : "Medium" }
                    label="Level of Effort"
                    sx={{ width: 200 }}
                    onChange={(e) => {setLOE(e.target.value)}}
                    inputProps={{
                        name: 'Name',
                        id: 'outlined-Name',
                     }}
                >
                    <MenuItem value="Easy">Easy (&#60; 5 min)</MenuItem>
                    <MenuItem value="Medium">Medium (&#60; 15 min)</MenuItem>
                    <MenuItem value="Hard">Hard (&#60; 1 hr)</MenuItem>
                    <MenuItem value="Very Hard">Very Hard</MenuItem>
                </Select>
            </div>
            <div className="row-form-field" style={{minWidth: 50}}>
                { props.variable.inheritedValue || props.variable.defaultValue ?
                    <IconButton 
                                variant="contained" 
                                color="primary"
                                aria-label={"Delete default value" }
                                size={"small"}
                                onClick={(e) => {
                                        setValue("");
                                    }}>
                                <Delete style={{color: "#003e51"}} />
                    </IconButton> : 
                                props.variable.success ?
                                    <div className="success-indicator">
                                         <CheckCircle /> 
                                    </div> : props.variable.success == false ?
                                    <div className="failure-indicator">
                                         <Error /> 
                                    </div> : <div className="failure-indicator">
                    
                                    </div>  
                    
                    
                    }
            </div> 
            



        </div>
    )
}

export default AddVariableRow;